import {
    Navigate,
    Route,
    Routes,
} from 'react-router-dom';

import {IndexPage} from './pages/IndexPage';
import {AddPage} from './pages/AddPage';
import {EditPage} from './pages/EditPage';
import {useVerifiedPermissions} from "../../hooks/useVerifiedPermissions.ts";

export const TagsLayout = () => {

    const {allowedActions} = useVerifiedPermissions()

    return (
        <Routes>
            <Route
                path='/'
                element={
                    allowedActions.includes('ListTags') ? (
                        <IndexPage/>
                    ) : (
                        <Navigate to='/'/>
                    )
                }
            />
            <Route
                path='add'
                element={
                    allowedActions.includes('CreateTag') ? (
                        <AddPage/>
                    ) : (
                        <Navigate to='/tags'/>
                    )
                }
            />
            <Route
                path=':id'
                element={
                    allowedActions.includes('GetTag') ? (
                        <EditPage/>
                    ) : (
                        <Navigate to='/tags'/>
                    )
                }
            />
        </Routes>
    );
};
